<template>
  <div class="mc-invoice-delivery">
    <div class="d-flex mc-list-header">
      <h4 class="card-title flex-grow-1">{{ $t('invoice.title.delivery') }}</h4>
    </div>
    <b-card>
      <b-table
        :busy="isBusy"
        :items="items"
        :fields="fields"
        fixed
        show-empty
      >
        <template #head()="data">
          {{ $t(data.label) }}
        </template>
        <template #cell()="{ value }">
          {{ value === '' ? '-' : value }}
        </template>
      </b-table>
    </b-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isBusy: false,
      fields: [
        { key: 'number', label: 'invoice.fields.deliveryNumber' },
        { key: 'sales_order.number', label: 'invoice.fields.noSO' },
        { key: 'billed_customer.name', label: 'invoice.fields.customer' },
        { key: 'origin_address.name', label: 'invoice.fields.originAddress' },
        { key: 'destination_address.name', label: 'invoice.fields.destinationAddress' },
        { key: 'load_count', label: 'invoice.fields.totalLoad' },
        { key: 'load_weight', label: 'invoice.fields.loadWeight' },
        { key: 'load_volume', label: 'invoice.fields.loadVolume' },
      ],
    }
  },
  computed: {
    items() {
      return this.$store.state.invoice.selectedDos
    }
  }
}
</script>
<style lang="scss" scoped>
.mc-invoice-delivery {
  .mc-list-header {
    margin-top: 12px;
    margin-bottom: 22px;
  }
}
</style>